import React from 'react'
import { XYChart, Axis, Grid, LineSeries, Tooltip } from '@visx/xychart'
import { addDays, format } from 'date-fns'
import { ParentSize } from '@visx/responsive'
import { useTranslation } from 'react-i18next'

const processData = (data: any[]) => {
    return data.map((item) => ({
        date: format(addDays(new Date(item.insight_date), 1), 'dd/MM'),
        total_exams: item.total_exams,
        logo_share: item.logo_share,
        exam_view_quantity: item.exam_view_quantity,
        baby_users_quantity: item.baby_users_quantity,
        booking_clicks: item.booking_clicks
    }))
}

const colorMap = {
    total_exams: '#0166FF',
    logo_share: '#5D4DEB',
    exam_view_quantity: '#E20101',
    baby_users_quantity: '#FEC551',
    booking_clicks: '#48E1C6'
}

const LineChart = ({ data, appDisabled = false }: any) => {
    const processedData = processData(data)
    const { t } = useTranslation()

    return (
        <ParentSize>
            {({ width, height }) => {
                const numTicksX = width < 500 ? 3 : 6

                return (
                    <XYChart height={height || 300} width={width} xScale={{ type: 'band' }} yScale={{ type: 'linear' }}>
                        <Grid columns={false} numTicks={4} />
                        <Axis orientation="bottom" numTicks={numTicksX} />

                        <LineSeries dataKey="total_exams" data={processedData} xAccessor={(d) => d.date} yAccessor={(d) => d.total_exams} stroke="#0166FF" />
                        {!appDisabled && <LineSeries dataKey="logo_share" data={processedData} xAccessor={(d) => d.date} yAccessor={(d) => d.logo_share} stroke="#5D4DEB" />}
                        <LineSeries dataKey="exam_view_quantity" data={processedData} xAccessor={(d) => d.date} yAccessor={(d) => d.exam_view_quantity} stroke="#E20101" />
                        {!appDisabled && (
                            <>
                                <LineSeries dataKey="baby_users_quantity" data={processedData} xAccessor={(d) => d.date} yAccessor={(d) => d.baby_users_quantity} stroke="#FEC551" />
                                <LineSeries dataKey="booking_clicks" data={processedData} xAccessor={(d) => d.date} yAccessor={(d) => d.booking_clicks} stroke="#48E1C6" />
                            </>
                        )}

                        <Tooltip
                            snapTooltipToDatumX
                            snapTooltipToDatumY
                            showVerticalCrosshair
                            showSeriesGlyphs
                            renderGlyph={(glyphData) => {
                                const color = colorMap[glyphData?.key as keyof typeof colorMap] || 'gray'
                                return <circle r={4} fill="white" stroke={color} strokeWidth={2} />
                            }}
                            renderTooltip={({ tooltipData }: any) => {
                                const datum = tooltipData?.nearestDatum?.datum
                                return (
                                    <div>
                                        <p style={{ fontSize: '16px', margin: '8px 0' }}>
                                            {t('components.lineChart.date')}: <span>{datum?.date}</span>
                                        </p>
                                        <p style={{ margin: '8px 0', color: colorMap.total_exams }}>
                                            {t('appEnabled.total_exams')}: <span>{datum?.total_exams}</span>
                                        </p>
                                        <p style={{ margin: '8px 0', color: colorMap.exam_view_quantity }}>
                                            {t('appEnabled.exam_view_quantity')}: <span>{datum?.exam_view_quantity}</span>
                                        </p>
                                        {!appDisabled && (
                                            <>
                                                <p style={{ margin: '8px 0', color: colorMap.logo_share }}>
                                                    {t('appEnabled.logo_share')}: <span>{datum?.logo_share}</span>
                                                </p>
                                                <p style={{ margin: '8px 0', color: colorMap.baby_users_quantity }}>
                                                    {t('appEnabled.baby_users_quantity')}: <span>{datum?.baby_users_quantity}</span>
                                                </p>
                                                <p style={{ margin: '8px 0', color: colorMap.booking_clicks }}>
                                                    {t('appEnabled.booking_clicks')}: <span>{datum?.booking_clicks}</span>
                                                </p>
                                            </>
                                        )}
                                    </div>
                                )
                            }}
                        />
                    </XYChart>
                )
            }}
        </ParentSize>
    )
}

export default LineChart
